<template lang="pug">
.card.shadow.mb-4
  .card-header.py-3
    h3.m-0.font-weight-bold.text-primary RMA Details / Refunds
    i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(@click="closeModal()")
  .card-body
    .createRMAForm(v-if="!loading")       
      .col-12
        h4 Order: {{rma.orderName}}
        p RMA No: # {{rma._id.toUpperCase().match(/.{1,6}/g).join('-')}}
        p Status: {{rma.status.replace(/^./,rma.status[0].toUpperCase())}}
      .col-12    
        table
          thead
            tr
              th Item
              th SKU
              th Vendor
              th Price
              th Quantity              
              th(v-if="orderInfo.type == 'shopify' && rma.status == 'approved'") Quantity to Refund
          tbody            
            tr(v-for="(item,index) in rma.items")              
              td 
                label(v-bind:for="`returnCheck${index}`") {{item.title}}            
              td 
                label(v-bind:for="`returnCheck${index}`") {{item.sku}}
              td 
                label(v-bind:for="`returnCheck${index}`") {{item.vendor}}
              td
                label(v-bind:for="`returnCheck${index}`") {{item.price}}
              td {{item.quantity}}
              //- td(v-if="orderInfo.type == 'shopify' && rma.status == 'approved' && (item.quantity - item.quantityRefunded) > 0")                
              //- td(v-else) {{item.quantity}}
              td(v-if="orderInfo.type == 'shopify' && rma.status == 'approved' && (item.quantity - item.quantityRefunded) > 0") 
                input( style="width:70px; margin-right:10px;" type="number" min="0" v-bind:max="(item.quantity - item.quantityRefunded)" v-model="item.quantityToReturn")                
                button.btn.btn-primary(@click="refundItems(index)") Refund
              td(v-else-if="orderInfo.type == 'shopify' && rma.status == 'approved' && (item.quantity - item.quantityRefunded) == 0") -
              //- td(v-else)
      br          
      .col-12
        p Reason: {{rma.reason}}      
      .col-12(v-show="rma.note")
        p Note: {{rma.note}}
      .col-12
        p Customer email: {{rma.email}}
      .col-12(v-if="rma.photos && rma.photos.length > 0")
        p Photos:
        .rma-photo(v-for="(photo) in rma.photos")
          img(:src="photo.url" onerror="this.onerror=null; this.src='https://s3.wasabisys.com/rp-widget/img/no_image.png'")
      .col-12.refundedTable
        h4 Refunded Items
        table
          thead
            tr
              th Item
              th SKU
              th Vendor
              th Price
              th Quantity Refunded
          tbody(v-for="item in rma.items")              
            tr(v-if="item.quantityRefunded > 0")
              td {{item.title}}
              td {{item.sku}}
              td {{item.vendor}}
              td {{item.price}}
              td {{item.quantityRefunded}}
            tr(v-else)
              td(colspan=5) N/A

</template>

<script>

import { mapState } from "vuex";
import convert from 'convert-units'
import moment from 'moment';
export default {
  name: 'RMADetails',
  components:{

  },

  props: {    
    orderInfo:Object,
  },
  data:function(){
    return{
      loading:true,
      
      allSelected:false,
      rma:null,
      selected:[],
    }
  },
  watch:{
      
  },
  computed:{
    ...mapState(['shopifyChannels','apiChannels', 'amazonChannels']),
    
  },
  methods:{
    closeModal(){
      this.$emit('closeOrder')
    },
    async refundItems(itemIndex){
      // Shopify only
      var theItem = {...this.rma.items[itemIndex]}
      if(theItem.quantityToReturn < 0 || theItem.quantityToReturn > theItem.quantity) this.flash(`Quantity to return cannot be less than 0 or greater than ${theItem.quantity - theItem.quantityRefunded}`, 'warning')
      else{
        var data = new FormData();
        data.append('orderId', this.orderInfo.orderId)
        data.append('rmaId', this.rma._id)
        data.append('storeUrl', this.orderInfo.storeUrl)
        data.append('lineItemId', theItem.id)
        data.append('quantity', theItem.quantityToReturn)
        try{
          this.flash('Refunding...','warning')
          var refundPost = await this.axios.post(`/rp/server/refunds/calculate`,data)
          if(refundPost.data.refund){
            this.flash(`You have successfully processed a refund.`,'success')            
            this.orderInfo.items[itemIndex].quantityRefunded = parseInt(this.orderInfo.items[itemIndex].quantityRefunded) + parseInt(theItem.quantityToReturn);
          }else{
            this.flash(`${refundPost.data.error.message}`,'error')
          }
        }catch(err){
          this.flash(`${err}`,'error')
        }
      }
          

    }
  },
  async mounted(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeOrder");
      }
    };
    this.rma = this.orderInfo;
    for(let i = 0; i<this.rma.items.length; i++){
      var {quantity, quantityRefunded} = this.rma.items[i];      
      this.rma.items[i].quantityToReturn = quantity - quantityRefunded      
    }
    this.loading = false;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .card{
    width:60vw;
  }
  .closeModal{
    position:absolute;
    right:20px;
    top:20px;
  }
  table{
    width:100%;
    label{
      margin:0;
    }
    tr{
      border-top:1px solid #e3e6f0;
      border-bottom:1px solid #e3e6f0;      
    }
  }
  button{
    margin:10px 0;
  }
  .refundedTable{
    margin-top:40px;
  }
  .rma-photo {
    width: 356px;
    height: 200px;

    img {
        width: auto;
        height: auto;
        max-height: 200px;
        border: 1px solid;
    }
  }
</style>
